export const smallScreenLimit = 768;

export const palette = {
  red: '#C53151',
  darkRed: '#7E2034',
  white: '#FAFAFA'
}

export const styles = {
  shadows: {
    inset: 'inset 0px -6px 10px rgba(0, 0, 0, 0.3);',
    drop: '0px 4px 4px rgba(0, 0, 0, 0.25);'
  }
}
